import React from 'react';

import type { AddressFromToFilter } from 'types/api/address';
import type { TransactionsSortingValue } from 'types/api/transaction';

import type { QueryWithPagesResult } from 'ui/shared/pagination/useQueryWithPages';
import getSortParamsFromValue from 'ui/shared/sort/getSortParamsFromValue';

import TxsContent from './TxsContent';

type Props = {

  query: QueryWithPagesResult<'address_txs'>;
  showBlockInfo?: boolean;
  showSocketInfo?: boolean;
  socketInfoAlert?: string;
  socketInfoNum?: number;
  currentAddress?: string;
  filter?: React.ReactNode;
  filterValue?: AddressFromToFilter;
  enableTimeIncrement?: boolean;
  top?: number;
  stickySurface?: boolean;
  sorting: TransactionsSortingValue | undefined;
  setSort: (value?: TransactionsSortingValue) => void;
  mobileExportButtonPosition?: 'inline' | 'belowPagination';
  variant?: 'default' | 'explorer';
  desktopTopSlot?: React.ReactNode;
  hideValueUsd?: boolean;
};

const TxsWithAPISorting = ({
  filter,
  filterValue,
  query,
  showBlockInfo = true,
  showSocketInfo = true,
  socketInfoAlert,
  socketInfoNum,
  currentAddress,
  enableTimeIncrement,
  top,
  stickySurface,
  sorting,
  setSort,
  mobileExportButtonPosition,
  variant,
  desktopTopSlot,
  hideValueUsd,
}: Props) => {

  const handleSortChange = React.useCallback((value?: TransactionsSortingValue) => {
    setSort(value);
    query.onSortingChange(getSortParamsFromValue(value));
  }, [ setSort, query ]);

  return (
    <TxsContent
      filter={ filter }
      filterValue={ filterValue }
      showBlockInfo={ showBlockInfo }
      showSocketInfo={ showSocketInfo }
      socketInfoAlert={ socketInfoAlert }
      socketInfoNum={ socketInfoNum }
      currentAddress={ currentAddress }
      enableTimeIncrement={ enableTimeIncrement }
      top={ top }
      stickySurface={ stickySurface }
      items={ query.data?.items }
      isPlaceholderData={ query.isPlaceholderData }
      isError={ query.isError }
      setSorting={ handleSortChange }
      sort={ sorting }
      query={ query }
      mobileExportButtonPosition={ mobileExportButtonPosition }
      variant={ variant }
      desktopTopSlot={ desktopTopSlot }
      hideValueUsd={ hideValueUsd }
    />
  );
};

export default TxsWithAPISorting;
